// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__tlRWi","content":"GlobalSearch_content__1Rw8s"};